import { useEffect, useRef } from 'react';
import { updateTechLocation } from '../services/crmBackendService';

export function useLocationTracking(techName, jobId = '', active = true) {
  const intervalRef = useRef(null);

  const send = () => {
    if (!techName || !navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        updateTechLocation({
          tech_name: techName,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          job_id: jobId,
          accuracy: pos.coords.accuracy,
        }).catch(() => {});
      },
      () => {},
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 30000 }
    );
  };

  useEffect(() => {
    if (!active || !techName) return;
    send();
    intervalRef.current = setInterval(send, 60000);
    return () => clearInterval(intervalRef.current);
  }, [active, techName, jobId]);
}
